import React from "react";
import { Box, Group, Drawer, Button, SegmentedControl, Text, Loader, Select, ActionIcon } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';

import { utils } from "../../utils/globalVariables";

import CustomerCategorySelectorMultiple from "../../components/general/CustomerCategorySelectorMultiple";
import GenderMaleFemaleUngenderedSelectorMultiple from "../../components/general/GenderMaleFemaleUngenderedSelectorMultiple";
import InputWrapperCustom from "../../components/general/InputWrapperCustom";

const CustomerFilter = ({
    stateShow,
    fnShow,
    stateDefaultFilter,
    stateLoading,
    stateFlag,
    stateFilter,
    fnFilter
}) => {

    const [data, setData] = React.useState({
        filterCustomerIsActive: stateFilter.filterCustomerIsActive,
    });

    const [genderSet, setGenderSet] = React.useState(stateFilter.filterCustomerGender);
    const [genderController, setGenderController] = React.useState(true);

    const [customerCategorySet, setCustomerCategorySet] = React.useState(stateFilter.filterCustomerCategory); /* flag all */
    const [customerCategoryController, setCustomerCategoryController] = React.useState(true);

    const [customerGroupId, setCustomerGroupId] = React.useState(stateFilter.filterCustomerGroupId);

    const handleFilter = () => {
        fnFilter(
            data.filterCustomerIsActive,
            customerCategorySet === utils.flagAll ? utils.flagAll : customerCategorySet,
            genderSet,
            customerGroupId
        )
    }

    const handleReset = () => {
        setData(d => ({
            ...d,
            filterCustomerIsActive: stateDefaultFilter.customerIsActive,
        }))

        setGenderSet(stateDefaultFilter.customerGender);
        setGenderController(true);

        setCustomerCategorySet(utils.flagAll);
        setCustomerCategoryController(true);

        setCustomerGroupId(stateDefaultFilter.customerGroupId)
    }

    /*  ----------- START GENDER ----------- */

    const handleSetGender = (arr) => {
        if (Object.values(utils.gender).map(obj => String(obj.value)).every(i => arr.includes(i))) {
            setGenderSet(Object.values(utils.gender).map(obj => String(obj.value)));
            setGenderController(true);
        } else {
            if (genderSet.length <= 1 && arr.length <= 0) {
                //
            } else {
                setGenderSet(arr);
                setGenderController(false);
            }
        }
    }

    const handleControllerGender = (isChecked) => {
        if (isChecked) {
            setGenderSet(Object.values(utils.gender).map(obj => String(obj.value)));
            setGenderController(true);
        } else {
            setGenderSet(['1']);
            setGenderController(false);
        }
    }

    /*  ----------- END GENDER ----------- */


    /*  ----------- START CUSTOMER CATEGORY ----------- */

    const handleSetCustomerCategory = (arr) => {
        if (Object.values(stateDefaultFilter.customerCategory).map(obj => String(obj.customer_category_slug)).every(i => arr.includes(i))) {
            setCustomerCategorySet(utils.flagAll);
            setCustomerCategoryController(true);
        } else {
            if (Array.isArray(customerCategorySet) && customerCategorySet.length <= 1 && arr.length <= 0) {
                //
            } else {
                setCustomerCategorySet(arr);
                setCustomerCategoryController(false);
            }
        }
    }

    const handleControllerCustomerCategory = (isChecked) => {
        if (isChecked) {
            setCustomerCategorySet(utils.flagAll);
            setCustomerCategoryController(true);
        } else {
            setCustomerCategorySet((Array.isArray(stateDefaultFilter.customerCategory) && stateDefaultFilter.customerCategory.length > 0) ? [stateDefaultFilter.customerCategory[0].customer_category_slug] : []);
            setCustomerCategoryController(false);
        }
    }

    /*  ----------- END CUSTOMER CATEGORY ----------- */

    return (
        <React.Fragment>
            <Drawer
                opened={stateShow}
                onClose={fnShow}
                withCloseButton={false}
                position="left"
                closeOnClickOutside={true}
                title={
                    <Group noWrap spacing='xs'>
                        <ActionIcon
                            size='lg'
                            variant="light"
                            radius='xl'
                            color="blue"
                            onClick={fnShow}
                        >
                            <IconArrowLeft size='1.25rem' stroke={1.5} />
                        </ActionIcon>

                        <Text>Filter Customer</Text>
                    </Group>
                }
                size='md'

                styles={() => ({
                    title: {
                        fontWeight: 'bold',
                        textTransform: 'uppercase'
                    }
                })}
            >
                <Box py='md'>
                    <Box mb='2rem'>
                        <InputWrapperCustom
                            stateLabel='Kategori Customer'
                            stateWithAsterisk={true}
                            stateError=''
                            stateDescription=''
                        >
                            <CustomerCategorySelectorMultiple
                                stateValue={customerCategorySet === utils.flagAll ? Object.values(stateDefaultFilter.customerCategory).map(obj => String(obj.customer_category_slug)) : customerCategorySet}
                                fnOnChange={handleSetCustomerCategory}
                                stateData={stateDefaultFilter.customerCategory}
                                stateDataLoading={stateLoading.customerCategory}
                                stateDataFlag={stateFlag.customerCategory}

                                stateController={customerCategoryController}
                                fnController={handleControllerCustomerCategory}
                            />
                        </InputWrapperCustom>
                    </Box>

                    <InputWrapperCustom
                        stateMB="2rem"
                        stateLabel={
                            <Group>
                                <Text>Customer Group</Text>
                                {stateLoading.customerGroup && <Loader size="xs" />}
                            </Group>
                        }
                        stateWithAsterisk={false}
                        stateError=''
                        stateDescription=''
                    >
                        <Select
                            // disabled={disabledSteps.includes(stateData.projectProcess)}
                            value={customerGroupId}
                            onChange={(val) => setCustomerGroupId(val)}
                            data={[
                                { value: utils.flagAll, label: 'Semua Group' },
                                ...stateDefaultFilter.customerGroup.map(key => ({ value: key.customer_group_id, label: key.customer_group_name }))
                            ]}

                            styles={(tema) => ({
                                input: {
                                    backgroundColor: tema.colorScheme === 'light' ? '#fff' : tema.colors.dark[7],
                                    "&[data-disabled=true]": {
                                        color: tema.colorScheme === 'light' ? tema.colors.dark[9] : tema.colors.gray[0]
                                    }
                                },
                                wrapper: {
                                    marginTop: '.75rem'
                                }
                            })}
                        />
                    </InputWrapperCustom>

                    <Box mb='2rem'>
                        <InputWrapperCustom
                            stateLabel='Gender'
                            stateWithAsterisk={true}
                            stateError=''
                            stateDescription=''
                        >
                            <GenderMaleFemaleUngenderedSelectorMultiple
                                stateValue={genderSet}
                                fnOnChange={handleSetGender}

                                stateController={genderController}
                                fnController={handleControllerGender}
                            />
                        </InputWrapperCustom>
                    </Box>

                    <Box mb='2rem'>
                        <InputWrapperCustom
                            stateLabel="Status Customer"
                            stateWithAsterisk={false}
                            stateError=''
                            stateDescription=''
                        >
                            <SegmentedControl
                                fullWidth
                                value={data.filterCustomerIsActive}
                                onChange={(val) => setData(d => ({ ...d, filterCustomerIsActive: val }))}
                                data={[
                                    { label: 'Semua', value: utils.flagAll },
                                    { label: 'Aktif', value: '1' },
                                    { label: 'Non Aktif', value: '0' },
                                ]}
                            />
                        </InputWrapperCustom>
                    </Box>

                    <Group position="apart" noWrap spacing='xs' my='xl' pt='xl'>
                        <Button
                            fullWidth
                            variant="default"
                            color='gray'
                            onClick={handleReset}
                        >
                            Reset
                        </Button>

                        <Button
                            fullWidth
                            // variant="default"
                            color='teal'
                            onClick={handleFilter}
                        >
                            Filter
                        </Button>
                    </Group>
                </Box>
            </Drawer>
        </React.Fragment>
    )
}

export default React.memo(CustomerFilter);